<div class="company-table-header-column w-100" #roleCell>
  <button class="d-flex btn align-items-center justify-content-center" (click)="onSortRequested($event)">
    <div class="header-label mb-1">{{ params.displayName | translate }}</div>
    @if (params.enableSorting) {
      <div class="d-flex align-items-center order-label ms-2">
        <i
          class="fa"
          [ngClass]="{ 'fa-sort-asc': order === 'asc', 'fa-sort-desc': order === 'desc', 'fa-sort': !order }"></i>
      </div>
    }
  </button>
  <div class="search-element-container">
    @if (colId === 'fullName') {
      <input
        [(ngModel)]="params.context.componentParent.localFilterParams.fullName"
        class="form-control"
        type="text"
        placeholder="{{ 'Type name' | translate }}..." />
    } @else if (colId === 'email') {
      <input
        [(ngModel)]="params.context.componentParent.localFilterParams.email"
        class="form-control"
        type="text"
        placeholder="{{ 'Type email' | translate }}..." />
    } @else if (colId === 'decisionMaker') {
      <select class="form-control" [(ngModel)]="params.context.componentParent.localFilterParams.decisionMaker">
        <option [ngValue]="''">{{ 'Select option' | translate }}...</option>
        <option [ngValue]="true">{{ 'Yes' | translate }}</option>
        <option [ngValue]="false">{{ 'No' | translate }}</option>
      </select>
    }
  </div>
</div>
